"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.msToHHMMSS = void 0;
function msToHHMMSS(ms) {
    var seconds = ms / 1000;
    var minutes = Math.floor(seconds / 60);
    var hours = Math.floor(minutes / 60);
    var formattedSeconds = formatPart(seconds);
    var formattedMinutes = formatPart(minutes);
    var formattedHours = formatPart(hours);
    if (formattedHours === '00') {
        formattedHours = '';
    }
    else {
        formattedHours += ':';
    }
    return "".concat(formattedHours).concat(formattedMinutes, ":").concat(formattedSeconds);
}
exports.msToHHMMSS = msToHHMMSS;
function formatPart(time) {
    var formattedTime = String(Math.floor(time >= 60 ? time % 60 : time));
    return formattedTime.length === 1
        ? '0' + formattedTime
        : formattedTime.slice(0, 2);
}
//# sourceMappingURL=time.js.map